import { Attribute } from "../Types/Attribute";

export interface RoomMeasurement {
    value: number;
    timestamp: string;
}
export interface MachineData {
    machineName: string;
    oee: Attribute;
    oee8h: Attribute;
    oee24h: Attribute;
    oee7d: Attribute;
    availability8h: Attribute;
    availability24h: Attribute;
    availability7d: Attribute;
    performance8h: Attribute;
    performance24h: Attribute;
    performance7d: Attribute;
    quality8h: Attribute;
    quality24h: Attribute;
    quality7d: Attribute;
    rapsInfo: { [key: string]: Attribute };
    energyConsumptionDaily: Attribute;
    co2equivalentsDaily: Attribute;
    co2equivalentsBatch: Attribute;
    co2equivalentsInsert: Attribute;
    roomTemperature: Attribute;
    roomHumidity: Attribute;
    roomPressure: Attribute;
    isProducing: Attribute;
}


export async function GetMachineData(elementGuid: string) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const url = `${apiUrl}/teams/machine?eguid=${elementGuid}`;

    console.log(`Attempting to fetch machine data from: ${url}`);

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        console.log(`Machine data response status: ${response.status}`);

        if (response.ok) {
            const data: MachineData = await response.json();
            console.log(`Successfully fetched machine data:`, data);
            return data;
        } else {
            console.error(`Failed to fetch machine data: ${response.status} ${response.statusText}`);
            return null;
        }
    } catch (error) {
        console.error("Failed to fetch machine data", error);
        return null;
    }
}
